import { Alert, Card, Center, Loader, Stack, Text, Title } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'

import { useBillingDisabledStatus } from '@/hooks/useBillingDisabledStatus'
import { useGlobalState } from '@/hooks/useGlobalState'

import { NoBillingAccount } from './NoBillingAccount'
import { PaymentMethodsSection } from './PaymentMethodsSection'

export function PaymentTab() {
  const { api } = useGlobalState()
  const { isBillingRestricted } = useBillingDisabledStatus()

  const billingInfoQuery = useQuery({
    queryKey: ['billing', 'info'],
    queryFn: () => api.getBillingInfo(),
  })

  const billingInfo = billingInfoQuery.data?.billingInfo
  const paymentMethod = billingInfo?.paymentMethod ?? null
  const isLoading = billingInfoQuery.isLoading

  if (isLoading) {
    return (
      <Center h={400}>
        <Loader size="lg" />
      </Center>
    )
  }

  if (billingInfoQuery.error || !billingInfo) {
    return <NoBillingAccount />
  }

  return (
    <Card shadow="sm" p="xl" radius="md" withBorder>
      <Stack gap="xl" px="20px">
        {isBillingRestricted && (
          <Alert icon={<IconAlertTriangle size={24} />} color="orange" variant="light">
            <Text fw={600} c="orange.8" size="md">
              Account Disabled Due to Billing
            </Text>
            <Text size="sm" c="orange.8">
              Your account has been disabled due to a billing issue. Please update your payment method to restore
              access.
            </Text>
          </Alert>
        )}

        <div>
          <Title order={4} mb="xs">
            Payment Information
          </Title>
          <Text size="sm" c="dimmed">
            Manage your payment method
          </Text>
        </div>

        <PaymentMethodsSection paymentMethod={paymentMethod} isLoading={isLoading} />

        <Text size="xs" c="dimmed" ta="center" style={{ fontStyle: 'italic' }}>
          Need help with billing? Contact us at{' '}
          <Text component="a" href="mailto:support@sidekickwellness.com" c="blue" td="underline">
            support@sidekickwellness.com
          </Text>
        </Text>
      </Stack>
    </Card>
  )
}
